import { useState } from "react";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { StyledAdsSellersValueDivider } from "app/pages/sales-intelligence/modules/apps-search-filters/components/filters/AppAdSellersFilter/styles";
import InclusionAdsSellersChip from "app/pages/sales-intelligence/modules/apps-search-filters/components/InclusionAdsSellersChip/InclusionAdsSellersChip";
import AdsSellersModal from "app/pages/sales-intelligence/modules/apps-search-filters/components/modals/AdsSellersModal/AdsSellersModal";
import type FindAppsAdsSellersFilter from "app/pages/sales-intelligence/modules/find-apps-filters/models/AdsSellersFilter/AdsSellersFilter";
import { hasSameAdsSellersObject } from "app/pages/sales-intelligence/modules/find-apps-filters/utils";
import type { IAppsAdSellersFilterItem } from "app/pages/sales-intelligence/store/find-apps/types";
import { operatorOptionMap } from "app/pages/sales-intelligence/types/commonMaps";

const AppAdSellersFilterResult = ({
    filter: { options },
    value = [],
    onFilterUpdate,
}: IFilterViewBaseProps<FindAppsAdsSellersFilter>) => {
    const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
    const [selectedItem, setSelectedItem] = useState<IAppsAdSellersFilterItem | null>(null);

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleApply = (item: IAppsAdSellersFilterItem, currentSelectedItem?: IAppsAdSellersFilterItem) => {
        const adsSellersValues = (value || []).map((adsSellersItem: IAppsAdSellersFilterItem) => {
            if (currentSelectedItem && hasSameAdsSellersObject(adsSellersItem, currentSelectedItem)) {
                return item;
            }

            return adsSellersItem;
        });
        onFilterUpdate(adsSellersValues);
        setIsOpenModal(false);
    };

    const handleOnDelete = (currentSelectedItem: IAppsAdSellersFilterItem) => {
        const filteredAdsSellers = value?.filter(
            (item: IAppsAdSellersFilterItem) => !hasSameAdsSellersObject(item, currentSelectedItem),
        );
        onFilterUpdate(filteredAdsSellers && filteredAdsSellers.length > 0 ? filteredAdsSellers : undefined);
    };

    const handleOnEdit = (currentSelectedItem: IAppsAdSellersFilterItem) => {
        setSelectedItem(currentSelectedItem);
        setIsOpenModal(true);
    };

    if (value?.length === 0) {
        return null;
    }

    return (
        <div>
            <AdsSellersModal
                isOpen={isOpenModal}
                selected={selectedItem}
                onClose={handleClose}
                onCancel={handleClose}
                onApply={handleApply}
                options={options}
                value={value}
            />

            {value.map((adSellers: IAppsAdSellersFilterItem, i) => (
                <>
                    {i > 0 ? (
                        <StyledAdsSellersValueDivider>{operatorOptionMap.and}</StyledAdsSellersValueDivider>
                    ) : null}
                    <InclusionAdsSellersChip
                        item={adSellers}
                        onEdit={handleOnEdit}
                        onDelete={handleOnDelete}
                    />
                </>
            ))}
        </div>
    );
};

export default AppAdSellersFilterResult;
